<app-shared-modal title="Settings" >
    <div>
      <div>
        <strong>Tenant Survey Files Folder: </strong><label>{{ surveyRootFolderPath }}</label>
      </div>
      <div>
        <strong>Datamart Database Server: </strong><label>{{ databaseSeverName }}</label>
      </div>      
      <div>
        <strong>Application Logs Folder: </strong><label>{{ applicationBaseUrl }}</label>
      </div>
    </div>
  </app-shared-modal>
  